export const PATROLS_POLLING_INTERVAL = 5000; // ms
export const PATROLS_POLLING_ONLINE_INTERVAL = 10000; // ms
export const PATROLS_POLLING_RESPONSE_INTERVAL = 2000; // ms

export enum PATROLS_REWARDS_ACTIONS {
  CLAIM = 'claim',
  REFRESH = 'refresh',
}

export enum PATROLS_REWARDS_UPDATE_STATUSES {
  ALLOWED = 1, // allowed
  NOT_ALLOWED = 2, // not allowed (already updated in 24h)
  NO_BUNDLES = 3, // not allowed (no more bundles available)
}
